import React from "react";
import { Reveal } from "./Reveal";
const stats = [{
  value: "+300",
  label: "Páginas prácticas"
}, {
  value: "+1.200",
  label: "Emprendedoras"
}, {
  value: "7",
  label: "Días de implementación"
}, {
  value: "100%",
  label: "Digital"
}];
export function StatsBar() {
  return <section className="w-full bg-white px-5 py-10" data-id="element-191" data-mp="1jckegnqlcwyq">
      <div className="mx-auto grid max-w-xl grid-cols-2 gap-6" data-id="element-192" data-mp="1jc2ebg0t5ylj">
        {stats.map((s, i) => <Reveal key={s.label} delay={i * 0.05} className="text-center" data-id="element-193" data-mp="1eeimtef3npbn" data-mpi={i}>
            <p className="font-serif-display text-3xl font-bold text-[#a04a63] sm:text-4xl" data-id="element-194" data-mp="19lg0nrcnji5h">
              {s.value}
            </p>
            <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-[#6b565b] sm:text-sm" data-id="element-195" data-mp="15it79m0c1p66">
              {s.label}
            </p>
          </Reveal>)}
      </div>
    </section>;
}